/**
 * POS-FULFILLMENT MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Route wrapper for the POS orders screen. Adapts Brand Command's auth context
// to the props the ported the source app page expects:
//  - `user`: shaped to { displayName, mail, username } so the modals can
//    pre-fill the submitter (the source app used MSAL fields of those names).
//  - `userPermissions`: a Set the page checks with .has(...). Workspace
//    owners/admins get POS shipping/edit/delete; ordinary members submit only.
//  - `onHome`: back-to-launcher navigation.
// The `.pos-module` wrapper supplies the the source app→BC CSS-variable bridge.
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../../shared/components/SessionProvider.jsx";
import { useWorkspaceAdmin } from "../../../shared/hooks/useWorkspaceAdmin.js";
import { displayName } from "../../../shared/utils/userDisplay.js";
import POSRequestPage from "../components/POSRequestPage.jsx";
import "../components/pos-tokens.css";

export default function PosOrders() {
  const navigate = useNavigate();
  const { user } = useSession();
  const { isWorkspaceAdmin } = useWorkspaceAdmin();

  const shapedUser = useMemo(
    () => ({ displayName: displayName(user), mail: user?.email || "", username: user?.email || "" }),
    [user]
  );
  const userPermissions = useMemo(
    () => new Set(isWorkspaceAdmin ? ["manage_pos_shipping"] : []),
    [isWorkspaceAdmin]
  );

  return (
    <div className="pos-module pos-dashboard">
      <POSRequestPage user={shapedUser} userPermissions={userPermissions} onHome={() => navigate("/")} />
    </div>
  );
}
